import React from "react";
import glamorous from "glamorous";
import _ from "lodash";
import { LadChicletCSS as Chiclet } from "../../components/chiclets";
import { getLadLobLabel } from "../../components/lads";
import LocationTypeSelectionFilterWidget from "./LocationTypeSelectionFilterWidget";

function selectionFilterMethod(filter, row) {
  if (filter.value.length === 0) {
    return true;
  }
  const rowLadLobLabel = getLadLobLabel(row.type).toLowerCase();
  const activeFilters = new Set(filter.value.map(v => v.toLowerCase()));
  return activeFilters.has(rowLadLobLabel);
}

const locationNameFilterMethod = (filter, row) => {
  return row.name.toLowerCase().includes(filter.value.toLowerCase());
};

const locationCodeFilterMethod = (filter, row) => {
  return row.code.toLowerCase().includes(filter.value.toLowerCase());
};

const locationAddressFilterMethod = (filter, row) => {
  const addressMash = _.join(
    _.map(
      _.pick(row.address, ["address", "city", "state", "zip"]),
      _.lowerCase
    ),
    " "
  );
  return addressMash.includes(filter.value.toLowerCase());
};

const LocationTypeCellRenderer = props => {
  const lad = props.value;

  if (lad == null) return <glamorous.Div height="100%" />;

  const label = getLadLobLabel(lad);

  return (
    <glamorous.Div
      display="flex"
      flexDirection="row"
      alignItems="center"
      height="100%"
    >
      <glamorous.Div marginLeft="1em">
        <Chiclet height={25} width={25} lad={lad} />
      </glamorous.Div>
      <glamorous.Div marginLeft="0.5em" marginRight="0.5em" width="100%">
        {label}
      </glamorous.Div>
    </glamorous.Div>
  );
};

const AddressCellRenderer = props => {
  const { address, city, state, zip } = props.value;

  if (address == null) {
    return null;
  }

  if (address.length === 0) {
    return null;
  }

  return (
    <div>
      <div>{`${address},`}</div>
      <div>{`${city}, ${state}, ${zip}`}</div>
    </div>
  );
};

const BoldCellRenderer = props => {
  return (
    <glamorous.Div
      css={{ fontWeight: "bold", textOverflow: "auto", overflow: "none" }}
    >
      {props.value}
    </glamorous.Div>
  );
};

const getLadFilterWidget = lads => ({ filter, onChange }) => {
  if (_.isEmpty(lads)) {
    return null;
  }
  const ladsGrouped = _.groupBy(lads, "lob_name");
  return LocationTypeSelectionFilterWidget(
    filter ? filter.value : [],
    ladsGrouped,
    val => onChange(val)
  );
};

export const getColumns = lads => {
  const ladAccessor = d =>
    lads.find(l => (d.lad ? l.id === Number(d.lad.id) : false));
  const ladFilterWidget = getLadFilterWidget(lads);

  return [
    {
      Header: "Name",
      accessor: "name",
      Cell: BoldCellRenderer,
      getProps: (state, rowInfo) => ({
        style: {
          paddingLeft: "10px",
          whiteSpace: "unset"
        }
      }),
      filterMethod: locationNameFilterMethod
    },
    {
      Header: "Location Type",
      id: "type",
      accessor: ladAccessor,
      Cell: LocationTypeCellRenderer,
      getProps: (state, rowInfo) => ({
        className: rowInfo && rowInfo.viewIndex % 2 ? "dark-even" : "dark-odd",
        style: {
          padding: "0px"
        }
      }),
      filterMethod: selectionFilterMethod,
      Filter: ladFilterWidget
    },
    {
      Header: "Location Code",
      accessor: "code",
      minWidth: 50,
      Cell: BoldCellRenderer,
      getProps: (state, rowInfo) => ({
        style: {
          paddingLeft: "10px"
        }
      }),
      filterMethod: locationCodeFilterMethod
    },
    {
      Header: "Address",
      id: "address",
      accessor: d => {
        return {
          address: d.address,
          city: d.city,
          state: d.state,
          zip: d.postal_code
        };
      },
      Cell: AddressCellRenderer,
      getProps: (state, rowInfo) => ({
        style: {
          paddingLeft: "10px"
        }
      }),
      filterMethod: locationAddressFilterMethod
    }
  ];
};



// WEBPACK FOOTER //
// ./src/modules/locations/LocationsColumns.js